import { useShowHamburger } from 'utils/helper-device'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import Form from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import React, { useEffect, useState } from 'react'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants'
import { useNavigation, useRoute } from '@react-navigation/native'
import _ from 'lodash'
import { timeslotKindExceptionAvailableForConstants } from 'utils/constants/timeslot-kind-esception-constants'
import FetchTimeslotKindExceptions from 'utils/fetch/FetchTimeslotKindExceptions'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import { AppRoutes } from 'navigations/app-routes'
import MutationManagementTimeslotKindException from 'graphql/mutations/management/MutationManagementTimeslotKindException'
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'
import SearchSelectUserComponent from 'components/management/molecules/SearchSelectUserComponent'
import MutateTimeslotKindExceptionTo from 'utils/mutate/timeslot-kind-exception-to'
import HelperString from 'utils/helper-string'
import SearchSelectTeamComponent from 'components/management/molecules/SearchSelectTeamComponent'
import { constantsActive } from 'utils/constants/constants'
import { createTimeslotKindTimeOptions } from 'utils/helper/management/TimeslotKindOptions'
import LoadingComponent from 'components/atoms/Loading'
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'
import SearchSelectJobtitleComponent from 'components/management/molecules/SearchSelectJobtitleComponent';

const ManagementTimeslotKindExceptionEditScene = () => {
	
	const showHamburger = useShowHamburger();
	const route = useRoute();
	const navigation = useNavigation();
	
	const defaultValues = {
		available_for: timeslotKindExceptionAvailableForConstants.EMPLOYEE,
		active: constantsActive.YES
	}
	
	const [ timeslotKind, setTimeslotKind ] = useState( {} )
	const [ timeslotKindException, setTimeslotKindException ] = useState( defaultValues )
	const [ loading, setLoading ] = useState( true )
	const [ updatedValues, setUpdatedValues ] = useState( defaultValues )
	
	const timeslotKindGuid = _.get( route.params, 'timeslotKindGuid', null );
	const timeslotKindExceptionGuid = _.get( route.params, 'timeslotKindExceptionGuid', null );
	
	const fetch = () => {
		// WHen not creating, fetch the exception
		if( timeslotKindExceptionGuid !== null ) {
			FetchTimeslotKindExceptions.fetch({
				guid: timeslotKindExceptionGuid,
				callbackSuccess: result => {
					const newTimeslotKind = _.get( result, 'timeslot_kind', {} );
					
					setTimeslotKind( newTimeslotKind )
					setTimeslotKindException( result )
					setUpdatedValues( result )
					setLoading( false )
				}
			})
			
			return;
		}
		
		FetchTimeslotKinds.fetch({
			guid: timeslotKindGuid,
			callbackSuccess: result => {
				setTimeslotKind( result )
				setTimeslotKindException( defaultValues )
				setLoading( false )
			}
		})
	}
	
	const onChange = ( values ) => {
		setUpdatedValues({
			...updatedValues,
			...values
		})
	}
	
	const onSubmit = (values, { callback } = {} ) => {
		values.timeslot_kind_guid = timeslotKind?.guid ?? timeslotKindGuid
		
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementTimeslotKindException, values )
			.setResultPath( ['mutation', 'timeslot_kind_exception'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS );
				
				if( _.get( timeslotKind, 'guid' ) !== result.guid ){
					navigation.replace( AppRoutes.MANAGEMENT_TIMESLOT_KIND_EXCEPTION_EDIT, {
						timeslotKindExceptionGuid: result.guid,
					});
				}else{
					fetch();
				}
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetch();
	}, [ timeslotKindExceptionGuid ] )
	
	const formFields = [
		{
			name: 'available_for',
			label: i18n.t('management:form.available_for.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{
					value: timeslotKindExceptionAvailableForConstants.EMPLOYEE,
					label: i18n.t( 'management:form.timeslot_kind_available_for.employee')
				},
				{
					value: timeslotKindExceptionAvailableForConstants.TEAM,
					label: i18n.t( 'management:form.timeslot_kind_available_for.team')
				},
				{
					value: timeslotKindExceptionAvailableForConstants.JOBTITLE,
					label: i18n.t( 'management:form.timeslot_kind_available_for.jobtitle')
				},
			]
		},
		{
			name: 'can_book_from',
			label: i18n.t('management:form.can_book_from.title'),
			type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
			options: createTimeslotKindTimeOptions({ present: false })
		},
		{
			name: 'can_book_until',
			label: i18n.t('management:form.can_book_until.title'),
			type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
			options: createTimeslotKindTimeOptions()
		},
		{
			name: 'can_cancel_until',
			label: i18n.t('management:form.can_cancel_until.title'),
			type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
			options: createTimeslotKindTimeOptions()
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		},
	]
	
	let content = [<LoadingComponent key={ HelperString.hash('timeslot-kind-exception-loading') } />]
	if( !loading ) {
		content = [
			<ThemedBlock
				key={ HelperString.hash('timeslot-kind-exception', timeslotKindException ) }
				shadow
				mediumPadding>
				
				<Form
					values={ timeslotKindException }
					fields={ formFields }
					onChange={ onChange }
					onSubmit={ onSubmit }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		]
		
		if( timeslotKindExceptionGuid !== null ) {

			switch( updatedValues.available_for ) {
				case timeslotKindExceptionAvailableForConstants.EMPLOYEE:
					content.push(
						<SearchSelectUserComponent
							key={ HelperString.hash('timeslot-kind-exception-employees', timeslotKindException ) }
							subtitle={ false }
							selectedEmployees={ _.map( timeslotKindException?.employees, o => {
								return o;
							} ) }
							onSubmit={ ( guids, { callback } ) => {
								MutateTimeslotKindExceptionTo.Employees( timeslotKindException.guid, guids, {
									callbackStart: () => {
										callback( FormStatus.LOADING )
									},
									callbackSuccess: result => {
										callback( FormStatus.SUCCESS );
									},
									callbackError: result => {
										callback( FormStatus.ERROR );
									}
								})
							}}
						/>
					)
					break;

				case timeslotKindExceptionAvailableForConstants.TEAM:
					content.push(
						<SearchSelectTeamComponent
							key={ HelperString.hash('timeslot-kind-exception-teams', timeslotKindException ) }
							subtitle={ false }
							selectedTeams={ _.map( timeslotKindException?.teams, o => {
								return o;
							} ) }
							onSubmit={ ( guids, { callback } ) => {
								MutateTimeslotKindExceptionTo.Teams( timeslotKindException.guid, guids, {
									callbackStart: () => {
										callback( FormStatus.LOADING )
									},
									callbackSuccess: result => {
										callback( FormStatus.SUCCESS );
									},
									callbackError: result => {
										callback( FormStatus.ERROR );
									}
								})
							}}
						/>
					)
					break;

				case timeslotKindExceptionAvailableForConstants.JOBTITLE:
					content.push(
						<SearchSelectJobtitleComponent
							key={ HelperString.hash('timeslot-kind-exception-jobtitles', timeslotKindException ) }
							subtitle={ false }
							selectedJobtitles={ _.map( timeslotKindException?.jobtitles, o => {
								return o;
							} ) }
							onSubmit={ ( guids, { callback } ) => {
								MutateTimeslotKindExceptionTo.Jobtitles( timeslotKindException.guid, guids, {
									callbackStart: () => {
										callback( FormStatus.LOADING )
									},
									callbackSuccess: result => {
										callback( FormStatus.SUCCESS );
									},
									callbackError: result => {
										callback( FormStatus.ERROR );
									}
								})
							}}
						/>
					)
					break;
			}
		}
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.timeslots.timeslotKinds.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}
				showBackButton={ true }>
				
				<VStack space={ ThemedValues.stackSpace }>
					{ content }
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementTimeslotKindExceptionEditScene
